import { useEffect, useState } from 'react'
import Pagination from '../components/commons/Pagination'
import { formatDate } from '../utils'
import { useAtom } from 'jotai'
import { getSubAdmins, setAsSubAdmin, removeSubAdmin } from '../firebase/subAdmins'
import DialogManageSubAdmin from '../components/dialogs/DailogManageSubAdmin'

const SubAdminManagement = () => {
    const [currentPage, setCurrentPage] = useState(1)
    const [users, setUsers] = useState([])
    const [selectedUser, setSelectedUser] = useState(null)
    const [loading, setLoading] = useState(true)
    const [showManageUserModal, setShowManageUserModal] = useState(false)
    const fields = ["User Name", 'Email', 'Phone', 'Account Created', 'Privileges', 'Actions']

    console.log("Users: ", users)
    useEffect(() => {
        updateUsers()
    }, [showManageUserModal])

    const updateUsers = () => {
        getSubAdmins().then((users) => {
            setUsers(users)
            // setSelectedUser(users[0])
            setLoading(false)
        })
    }

    const handleManageUser = (user) => {
        setSelectedUser(user)
        setShowManageUserModal(true)
    }

    return (
        <>
            {
                <DialogManageSubAdmin
                    open={showManageUserModal}
                    user={selectedUser}
                    onClose={() => setShowManageUserModal(false)}
                />
            }

            <div className="px-10 py-8">
                <div className='flex flex-row align-items-center justify-between'>
                    <h1 className="text-primary text-[36px]">Sub Admin Manager</h1>

                    <button className="text-white text-sm rounded-[44px] h-[45px] relative bg-[#2f2f2f] pl-[10px] pr-[10px]"
                            onClick={() => {
                                setSelectedUser(null)
                                setShowManageUserModal(true)
                            }}>
                        Add Sub Admin
                    </button>
                </div>

                {loading ? (
                    <div className="flex items-center justify-center h-64">
                        <div className="flex flex-col items-center">
                            <img src="/assets/icons/icon-loading.svg" alt="loading" className="w-8 h-8 animate-spin mb-4" />
                            <p className="text-white text-lg">Loading sub-admins...</p>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="mb-10 mt-7">
                            <div className="w-full overflow-auto">
                                <table className="w-full">
                                    <thead>
                                        <tr className="bg-[#2E2E2E] rounded-[4px] py-3 text-sm text-[#717171]">
                                            {
                                                fields.map((item, index) =>
                                                    <th className={`py-3 text-left ${index > 0 ? '' : 'pl-3'}`} key={`offer-field-${item}-${index}`}>
                                                        {item}
                                                    </th>
                                                )
                                            }
                                        </tr>
                                    </thead>

                                    <tbody className="text-white space-y-1 text-sm">
                                        {
                                            users.slice(8 * (currentPage - 1), 8 * currentPage).map(user =>
                                                <tr key={user.id} className='h-[70px] hover:bg-[#2F2F2F] p-2  rounded-[10px] overflow-hidden'>
                                                    {/* <td className='w-[100px] pl-2'>
                                                        <img alt='picture' src={user.picture} className='w-[55px] h-[55px] object-cover' />
                                                    </td> */}

                                                    <td className='pl-3'>
                                                        {user.displayName}
                                                    </td>

                                                    <td>
                                                        {user.email}
                                                    </td>

                                                    <td>
                                                        {user.phoneNumber}
                                                    </td>

                                                    <td>
                                                        {
                                                            user.created_at ? formatDate(user.created_at.seconds) : 'N/A'
                                                        }
                                                    </td>
                                                    <td>
                                                        {
                                                            user.privileges && user.privileges.length > 0 ? user.privileges.join(', ') : ''
                                                        }
                                                    </td>

                                                    <td>
                                                        <div className='flex justify-end pr-10'>
                                                            <button
                                                                className="px-6 py-2 bg-white text-black rounded-[33px]"
                                                                onClick={() => handleManageUser(user)}
                                                            >Edit</button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="mt-auto">
                            <Pagination itemsPerPage={8} totalItems={users.length} onPageChange={(v) => { setCurrentPage(v) }} />
                        </div>
                    </>
                )}
            </div>
        </>
    )
}

export default SubAdminManagement